import { LazyMotion, domMax } from 'framer-motion';
import type { ReactNode } from 'react';

// ----------------------------------------------------------------------

/** Loads framer-motion's full feature set once, for all `m.*` elements. */
export default function MotionLazyContainer({ children }: { children: ReactNode }) {
  return (
    <LazyMotion strict features={() => Promise.resolve(domMax)}>
      {children}
    </LazyMotion>
  );
}
